import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService, EventsService, PusherService, ScriptLoaderService, VariablesService } from '../../shared/services';

@Component({
  selector: 'app-truecaller-popup',
  templateUrl: './truecaller-popup.component.html',
  styleUrls: ['./truecaller-popup.component.scss']
})
export class TruecallerPopupComponent implements OnInit {

  @Input() execute: Observable<any>;

  acceptedTrueCallerAuth;

  constructor(
    private pusherService: PusherService,
    private scriptLoaderService: ScriptLoaderService,
    private authService: AuthService,
    public variablesService: VariablesService,
    private eventsService: EventsService,
  ) { }

  ngOnInit() {
    this.execute.subscribe((res) => {
      if (!this.acceptedTrueCallerAuth) {
        this.setTruecallerConfig();
      }
    });
  }


  setTruecallerConfig() {
    this.acceptedTrueCallerAuth = true;
    const req_nonce = new Date().valueOf().toString();
    this.variablesService.req_nonce = req_nonce;
    this.authService.trueCallerAuth(req_nonce);
    this.scriptLoaderService.load('pusher').then(() => {
      this.pusherService.pusher('phoneverification', 'truecaller');
      this.pusher('phoneverification');
      this.sendEvent('true_caller_popup');
    });
  }


  async pusher(channel) {
    this.pusherService.channelName = channel;
    const pusherChannel: any = await this.pusherService.pusherTruecallerObj.subscribe();
    pusherChannel.bind(channel, (event) => {
      if (!event.status && event.status !== 'user_rejected') {
        if (event.phone) {
          const phone = event.phone.toString();
          event.phone = phone.substring(phone.length - 10, phone.length);
          this.sendEvent('true_caller_prefilled');
          this.variablesService.trucallerRes.next(event);
        }
      }
    });
  }

  sendEvent(event_name) {
    const systemEvent = {
      eventName: event_name,
      page_name: this.variablesService.pageName
    };
    this.eventsService.sendSystemEvent(systemEvent).subscribe(_ => _);
  }

}
